import { render, staticRenderFns } from "./ParticipantEditCard.vue?vue&type=template&id=23c806ab&scoped=true"
import script from "./ParticipantEditCard.vue?vue&type=script&lang=js"
export * from "./ParticipantEditCard.vue?vue&type=script&lang=js"
import style0 from "./ParticipantEditCard.vue?vue&type=style&index=0&id=23c806ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c806ab",
  null
  
)

export default component.exports